export const vw = px => {
    return ((px / 1280) * 100) + 'vw';
}